import Anna from "../../assets/combatants/disney/anna.png";
import AnnaIcon from "../../assets/combatants/disney/anna-icon.png";
import AnnaWin from "../../assets/combatants/disney/anna-win.png";
import AnnaLose from "../../assets/combatants/disney/anna-lose.png";

import Ariel from "../../assets/combatants/disney/ariel.png";
import ArielIcon from "../../assets/combatants/disney/ariel-icon.png";
import ArielWin from "../../assets/combatants/disney/ariel-win.png";
import ArielLose from "../../assets/combatants/disney/ariel-lose.png";

import Aurora from "../../assets/combatants/disney/aurora.png";
import AuroraIcon from "../../assets/combatants/disney/aurora-icon.png";
import AuroraWin from "../../assets/combatants/disney/aurora-win.png";
import AuroraLose from "../../assets/combatants/disney/aurora-lose.png";

import Belle from "../../assets/combatants/disney/belle.png";
import BelleIcon from "../../assets/combatants/disney/belle-icon.png";
import BelleWin from "../../assets/combatants/disney/belle-win.png";
import BelleLose from "../../assets/combatants/disney/belle-lose.png";

import Elsa from "../../assets/combatants/disney/elsa.png";
import ElsaIcon from "../../assets/combatants/disney/elsa-icon.png";
import ElsaWin from "../../assets/combatants/disney/elsa-win.png";
import ElsaLose from "../../assets/combatants/disney/elsa-lose.png";

import Jasmine from "../../assets/combatants/disney/jasmine.png";
import JasmineIcon from "../../assets/combatants/disney/jasmine-icon.png";
import JasmineWin from "../../assets/combatants/disney/jasmine-win.png";
import JasmineLose from "../../assets/combatants/disney/jasmine-lose.png";

import Megara from "../../assets/combatants/disney/megara.png";
import MegaraIcon from "../../assets/combatants/disney/megara-icon.png";
import MegaraWin from "../../assets/combatants/disney/megara-win.png";
import MegaraLose from "../../assets/combatants/disney/megara-lose.png";

import Mulan from "../../assets/combatants/disney/mulan.png";
import MulanIcon from "../../assets/combatants/disney/mulan-icon.png";
import MulanWin from "../../assets/combatants/disney/mulan-win.png";
import MulanLose from "../../assets/combatants/disney/mulan-lose.png";

import Rapunzel from "../../assets/combatants/disney/rapunzel.png";
import RapunzelIcon from "../../assets/combatants/disney/rapunzel-icon.png";
import RapunzelWin from "../../assets/combatants/disney/rapunzel-win.png";
import RapunzelLose from "../../assets/combatants/disney/rapunzel-lose.png";

export const seriesId = "disney";

export default {
  anna: {
    seriesId,
    id: "anna",
    name: "Anna",
    description:
      "Anna s the second-born daughter of King Agnarr and Queen Iduna, the younger sister of Elsa, and the contemporary ruler of Arendelle.",
    img: Anna,
    icon: AnnaIcon,
    opWinImg: AnnaWin,
    opLoseImg: AnnaLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "youthful",
    eyeColor: "blue",
    hairColor: "aubrun",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 1,
    throatSize: 2,
    prefAttack: "vagina",
    prefTarget: "mouth",
    uniqueAttackText:
      "Anna gently caresses the inside of xxxx's pussy with her soft tongue.",
    roughPlayLvl: -10,
    seductionResistance: 65,
    grapplingProwess: 55,
    tongueProwess: 34,
    touchProwess: 48,
    cockProwess: 35,
    vaginaProwess: 52,
    anusProwess: 35,
    touchResistance: 28,
    breastResistance: 40,
    mouthResistance: 34,
    cockResistance: 35,
    vaginaResistance: 55,
    anusResistance: 42,
    orgasmLimit: 3,
  },
  ariel: {
    seriesId,
    id: "ariel",
    name: "Ariel",
    description:
      "She is the seventh and youngest daughter of King Triton and Queen Athena, rulers of the undersea kingdom of Atlantica.",
    img: Ariel,
    icon: ArielIcon,
    opWinImg: ArielWin,
    opLoseImg: ArielLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "tight",
    eyeColor: "blue",
    hairColor: "red",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "mouth",
    uniqueAttackText:
      "Ariel slips her long slippery tongue into xxxx's mouth, french kissing them passionately.",
    roughPlayLvl: 15,
    seductionResistance: 75,
    grapplingProwess: 72,
    tongueProwess: 70,
    touchProwess: 35,
    cockProwess: 40,
    vaginaProwess: 50,
    anusProwess: 35,
    touchResistance: 25,
    breastResistance: 60,
    mouthResistance: 70,
    cockResistance: 30,
    vaginaResistance: 55,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  aurora: {
    seriesId,
    id: "aurora",
    name: "Aurora",
    description:
      "Aurora is the daughter of King Stefan and Queen Leah. Cursed to sleep forever, she was broken free by true love's kiss.",
    img: Aurora,
    icon: AuroraIcon,
    opWinImg: AuroraWin,
    opLoseImg: AuroraLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "hourglass",
    eyeColor: "black",
    hairColor: "blonde",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "touch",
    prefTarget: "touch",
    uniqueAttackText:
      "Aurora presses her soft breasts against xxxx's back and massages them with her body.",
    roughPlayLvl: 5,
    seductionResistance: 45,
    grapplingProwess: 68,
    tongueProwess: 35,
    touchProwess: 65,
    cockProwess: 35,
    vaginaProwess: 35,
    anusProwess: 52,
    touchResistance: 64,
    breastResistance: 32,
    mouthResistance: 45,
    cockResistance: 38,
    vaginaResistance: 55,
    anusResistance: 45,
    orgasmLimit: 3,
  },
  jasmine: {
    seriesId,
    id: "jasmine",
    name: "Jasmine",
    description:
      "Jasmine is an independent, rebellious young princess from Agrabah, a Middle Eastern kingdom ruled by her father, the Sultan.",
    img: Jasmine,
    icon: JasmineIcon,
    opWinImg: JasmineWin,
    opLoseImg: JasmineLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "tight",
    eyeColor: "brown",
    hairColor: "black",
    skinColor: "tanned",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 3,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "vagina",
    prefTarget: "cock",
    uniqueAttackText:
      "Jasmine cowgirls herself excitedly on xxxx's erect cock.",
    roughPlayLvl: 22,
    seductionResistance: 70,
    grapplingProwess: 64,
    tongueProwess: 45,
    touchProwess: 25,
    cockProwess: 35,
    vaginaProwess: 70,
    anusProwess: 45,
    touchResistance: 52,
    breastResistance: 40,
    mouthResistance: 32,
    cockResistance: 45,
    vaginaResistance: 58,
    anusResistance: 38,
    orgasmLimit: 3,
  },
  belle: {
    seriesId,
    id: "belle",
    name: "Belle",
    description:
      "Belle is the only daughter of Maurice, an inventor with whom she resides in a small, French village. She is a  free-spirit andp proud bibliophile.",
    img: Belle,
    icon: BelleIcon,
    opWinImg: BelleWin,
    opLoseImg: BelleLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "human",
    bodyShape: "hourglass",
    eyeColor: "green",
    hairColor: "red",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "touch",
    prefTarget: "breasts",
    uniqueAttackText:
      "Belle softly gropes xxxx's heavy breasts, kneading them tenderly.",
    roughPlayLvl: -5,
    seductionResistance: 65,
    grapplingProwess: 65,
    tongueProwess: 35,
    touchProwess: 70,
    cockProwess: 45,
    vaginaProwess: 45,
    anusProwess: 30,
    touchResistance: 65,
    breastResistance: 65,
    mouthResistance: 40,
    cockResistance: 55,
    vaginaResistance: 55,
    anusResistance: 50,
    orgasmLimit: 3,
  },
  elsa: {
    seriesId,
    id: "elsa",
    name: "Elsa",
    description:
      "Elsa was born with the power of ice and snow, and is the firstborn daughter of King Agnarr and Queen Iduna.",
    img: Elsa,
    icon: ElsaIcon,
    opWinImg: ElsaWin,
    opLoseImg: ElsaLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "curvaceous",
    eyeColor: "blue",
    hairColor: "blonde",
    skinColor: "pale",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "cock",
    uniqueAttackText:
      "Elsa expertly slathers xxxx's cock with her tongue, and pushes it deep into her mouth.",
    roughPlayLvl: 25,
    seductionResistance: 70,
    grapplingProwess: 75,
    tongueProwess: 70,
    touchProwess: 50,
    cockProwess: 25,
    vaginaProwess: 35,
    anusProwess: 25,
    touchResistance: 35,
    breastResistance: 65,
    mouthResistance: 70,
    cockResistance: 35,
    vaginaResistance: 60,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  megara: {
    seriesId,
    id: "megara",
    name: "Megara",
    description:
      "Megara is a snarky 'femme fetale', she once served as a reluctant minion of Hades, to whom she was indebted.",
    img: Megara,
    icon: MegaraIcon,
    opWinImg: MegaraWin,
    opLoseImg: MegaraLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "lithe",
    eyeColor: "purple",
    hairColor: "brown",
    skinColor: "light tan",
    height: 2,
    penisSize: 0,
    breastSize: 2,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 3,
    prefAttack: "tongue",
    prefTarget: "anus",
    uniqueAttackText:
      "Megara presses her face between xxxx's arsecheeks and pleasures their ring.",
    roughPlayLvl: 15,
    seductionResistance: 68,
    grapplingProwess: 65,
    tongueProwess: 62,
    touchProwess: 40,
    cockProwess: 35,
    vaginaProwess: 42,
    anusProwess: 35,
    touchResistance: 42,
    breastResistance: 50,
    mouthResistance: 68,
    cockResistance: 35,
    vaginaResistance: 55,
    anusResistance: 25,
    orgasmLimit: 3,
  },
  mulan: {
    seriesId,
    id: "mulan",
    name: "Mulan",
    description:
      "Mulan is the strong-willed and tenacious daughter of a war veteran, who strives to uphold her family's honor.",
    img: Mulan,
    icon: MulanIcon,
    opWinImg: MulanWin,
    opLoseImg: MulanLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "black",
    hairColor: "black",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 3,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 2,
    prefAttack: "touch",
    prefTarget: "vagina",
    uniqueAttackText: "Mulan's tender fingers softly tease xxxx's wet pussy.",
    roughPlayLvl: 15,
    seductionResistance: 70,
    grapplingProwess: 62,
    tongueProwess: 35,
    touchProwess: 65,
    cockProwess: 25,
    vaginaProwess: 45,
    anusProwess: 45,
    touchResistance: 50,
    breastResistance: 45,
    mouthResistance: 50,
    cockResistance: 42,
    vaginaResistance: 65,
    anusResistance: 34,
    orgasmLimit: 3,
  },
  rapunzel: {
    seriesId,
    id: "rapunzel",
    name: "Rapunzel",
    description:
      "Rapunzel is the princess of Corona, known for her long, magical, golden hair. As a child, she was abducted & locked away in a remote tower.",
    img: Rapunzel,
    icon: RapunzelIcon,
    opWinImg: RapunzelWin,
    opLoseImg: RapunzelLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "petite",
    eyeColor: "green",
    hairColor: "blonde",
    skinColor: "pale",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 2,
    throatSize: 2,
    prefAttack: "tongue",
    prefTarget: "breasts",
    uniqueAttackText: "Rapunzel eagerly kisses and pleasures xxxx' breasts.",
    roughPlayLvl: -10,
    seductionResistance: 68,
    grapplingProwess: 60,
    tongueProwess: 62,
    touchProwess: 22,
    cockProwess: 35,
    vaginaProwess: 25,
    anusProwess: 28,
    touchResistance: 45,
    breastResistance: 42,
    mouthResistance: 58,
    cockResistance: 28,
    vaginaResistance: 60,
    anusResistance: 38,
    orgasmLimit: 3,
  },
};
